import { render } from "./SongEditor.vue?vue&type=template&id=1930e3cc&scoped=true"
import script from "./SongEditor.vue?vue&type=script&lang=js"
export * from "./SongEditor.vue?vue&type=script&lang=js"

import "./SongEditor.vue?vue&type=style&index=0&id=1930e3cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1930e3cc"]])

export default __exports__